import styled from "styled-components";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { $dmSansFontFamily, $robotoFontFamily } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";

export const StyledFooter = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: ${colorsPalettes.carbon[0]};

    & > button:first-child {
        margin-right: 8px;
    }
`;

export const StyledModalTitle = styled.div`
    ${setFont({
        $size: 20,
        $weight: 500,
        $family: $dmSansFontFamily,
        $color: colorsPalettes.carbon[500],
    })};
    line-height: 24px;
    margin-bottom: 36px;
    display: flex;
`;

export const StyledContent = styled.div`
    ${setFont({
        $size: 16,
        $weight: 400,
        $family: $robotoFontFamily,
        $color: colorsPalettes.carbon[500],
    })};
    margin-bottom: 34px;
    line-height: 20px;
`;

export const CUSTOM_DELETE_FIELD_MODAL_STYLES = {
    content: { padding: "20px 16px 16px 24px", width: 562, border: 0 },
    overlay: {
        backgroundColor: rgba(colorsPalettes.midnight["300"], 0.7),
    },
};
